import type {ObjectContext} from "../api/client";
import {StatusBadge} from "./StatusBadge";

export function ContextHeader({context}: {context: ObjectContext}) {
  return <header className="context-header">
    <nav aria-label="Breadcrumb"><ol>
      {context.accessibleAncestors.map(item => <li key={item.id}><a href={item.url}>{item.key}</a></li>)}
      <li aria-current="page">{context.subject.key}</li>
    </ol></nav>
    <div className="context-identity">
      <div><p className="eyebrow">{context.subject.type.replaceAll("_", " ")} workspace</p>
        <h1>{context.subject.key} — {context.subject.title}</h1></div>
      <StatusBadge value={context.subject.lifecycle} />
    </div>
    <dl className="context-facts">
      <div><dt>Scope</dt><dd>{context.company} / {context.businessUnit}</dd></div>
      <div><dt>Owner</dt><dd>{context.ownerOrganization ?? "Not assigned"}</dd></div>
      {context.risk && <div><dt>Risk / priority</dt><dd>{context.risk} / {context.priority}</dd></div>}
      {context.namedApprover && <div><dt>Named approver</dt><dd>{context.namedApprover}</dd></div>}
      {context.recordOrigin && <div><dt>Record origin</dt><dd>{context.recordOrigin.replaceAll("_", " ")}</dd></div>}
      <div><dt>Next valid action</dt><dd>{context.nextValidAction.replaceAll("_", " ")}</dd></div>
    </dl>
    <section className="action-availability" aria-labelledby="available-actions-heading">
      <h2 id="available-actions-heading">Server-authorized actions</h2>
      <ul>{context.availableActions.map(action => <li key={action.actionId}
        className={action.available ? "action-allowed" : "action-blocked"}>
        <span aria-hidden="true">{action.available ? "✓" : "×"}</span>
        <div><strong>{action.actionId.replaceAll("_", " ")}</strong>
          <p>{action.reason}</p><small>{action.reasonCode} · {action.requiredActorClass}</small></div>
      </li>)}</ul>
    </section>
    <p className="context-freshness">Observed {new Date(context.observedAt).toLocaleString()} · {context.freshness.replaceAll("_", " ")}</p>
  </header>;
}
